import { axiosInstance } from '@/plugins/axios';

export default {
  namespaced: true,
  state: {
    moods: {},
    humor: {},
    humorQuestion: {},
    humorQuestions: {},
    isPremium: false,
  },
  getters: {
    moods(state) {
      return state.moods;
    },
    humor(state) {
      return state.humor;
    },
    isPremium(state) {
      return state.isPremium;
    },
    humorQuestion(state) {
      return state.humorQuestion;
    },
    humorQuestions(state) {
      return state.humorQuestions;
    }
  },
  mutations: {
    SET_MOODS(state, value) {
      state.moods = value;
    },
    SET_HUMOR(state, value) {
      state.humor = value;
    },
    SET_IS_PREMIUM(state, value) {
      state.isPremium = value;
    },
    SET_HUMOR_QUESTION(state, value) {
      state.humorQuestion = value;
    },
    SET_HUMOR_QUESTIONS(state, value) {
      state.humorQuestions = value;
    }
  },
  actions: {
    async registerHumor(context, value) {

      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('name', value.name);
      formData.append('picture', value.picture);
      formData.append('is_premium', value.is_premium);

      const url = value?.id ? `humor/${value.id}` : 'humor';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultMoods');
        })
    },
    async consultMoods(context, value) {
      const url = value?.id ? `humor/${value.id}` : 'humor';
      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          if (value?.id) {
            context.dispatch('setDataDefault', ['SET_HUMOR', data]);
            return;
          }
          context.dispatch('setDataDefault', ['SET_MOODS', data]);
        })
    },
    async consultMoodsFiltered(context, value) {
      const url = value?.id ? `humor/filtered/${value.id}` : 'humor/filtered';
      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          if (value?.id) {
            context.dispatch('setDataDefault', ['SET_HUMOR', data]);
            return;
          }
          context.dispatch('setDataDefault', ['SET_MOODS', data]);
        })
    },
    async removeMeditation(context, id) {
      await axiosInstance({
        method: 'DELETE',
        url: `meditation/${id}`,
      }).then(response => response.data)
        .then(data => {
          context.dispatch('setDataDefault', ['SET_MEDITATION', data]);
        })
    },
    async registerHumorQuestions(context, value) {
      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('ids_humor', value.ids_humor);
      formData.append('questions', JSON.stringify(value.questions));
      formData.append('humorHasPost', JSON.stringify(value.humorHasPost));
      formData.append('humorHasPlan', JSON.stringify(value.humorHasPlan));
      formData.append('humorHasMeditation', JSON.stringify(value.humorHasMeditation));
      formData.append('humorHasMeditationMusic', JSON.stringify(value.humorHasMeditationMusic));


      const url = value?.ids_humor ? `humor/question?idsHumor=${value.ids_humor}` : 'humor/question';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultHumorQuestions', { ids: value.ids_humor });
        })
    },
    async consultHumorQuestions(context, value) {
      console.log('CONSULT HUMOR QUESTIONS', value);
      const url = value?.ids ? `humor/question?idsHumor=${value.ids}` : 'humor/question';

      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          if (value?.ids) {
            context.dispatch('setDataDefault', ['SET_HUMOR_QUESTION', data]);
            return;
          }
          context.dispatch('setDataDefault', ['SET_HUMOR_QUESTIONS', data]);
        })
    },
    async registerQuestions(context, value) {
      console.log('REGISTER QUESTIONS', value);
      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('question', value.question);
      formData.append('ids_humor', JSON.stringify(value.ids_humor));
      formData.append('options', JSON.stringify(value.options));

      const url = value?.id ? `humor/question/register/${value.id}` : 'humor/question/register';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultHumorQuestions', { ids: value.ids_humor });
        })
    },
    async removeQuestions(context, value) {
      console.log('REMOVE QUESTIONS', value);
      await axiosInstance({
        method: 'DELETE',
        url: `humor/question/register/${value.id_humor_question}`,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultHumorQuestions', { ids: value.ids_humor });
        })
    },
    async registerHumorQuestionsOptions(context, value) {
      let formData = new FormData();
      formData.append('id', value.id);
      formData.append('id_user', value.id_user);
      formData.append('id_question_humor', value.id_question_humor);
      formData.append('option', value.options);

      await axiosInstance({
        method: 'POST',
        url: `humor/question/options/${value?.id}`,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultHumorQuestions', { id: value.id_question_humor });
        })
    },
    async removeHumorQuestionsOptions(context, value) {
      await axiosInstance({
        method: 'DELETE',
        url: `humor/question/options/${value?.id}`,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultHumorQuestions', { id: value.id_question_humor });
        })
    },
    async removeHumorQuestion(context, value) {
      console.log('REMOVE HUMOR QUESTION', value);

      const elementExist = context.getters.humorQuestion.data.some(obj => obj.id === value.id);
      if (!elementExist) return;

      await axiosInstance({
        method: 'DELETE',
        url: `humor/question/${value.id}`,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultMoods');
        })
    },
    async removeHumorPosts(context, value) {
      console.log('REMOVE HUMOR POSTS', value);

      const elementExist = context.getters.humorQuestion.humorHasPost.some(obj => obj.id_post === value.id_post);
      if (!elementExist) return;

      await axiosInstance({
        method: 'DELETE',
        url: `humor/posts/${value.id_post}`,
        data: {
          ids_humor: value.ids_humor
        }
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultHumorQuestions', { ids: value.ids_humor });
        })
    },
    async removeHumorPlans(context, value) {
      console.log('REMOVE HUMOR PLANS', value);

      const elementExist = context.getters.humorQuestion.humorHasPlan.some(obj => obj.id === value.id);
      if (!elementExist) return;

      await axiosInstance({
        method: 'DELETE',
        url: `humor/plans/${value.id}`,
        data: {
          ids_humor: value.ids_humor
        }
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultHumorQuestions', { ids: value.ids_humor });
        })
    },
    async removeHumorMeditation(context, value) {
      console.log('REMOVE HUMOR MEDITATION', value);

      const elementExist = context.getters.humorQuestion.humorHasMeditation.some(obj => obj.id === value.id);
      if (!elementExist) return;

      await axiosInstance({
        method: 'DELETE',
        url: `humor/meditation/${value.id}`,
        data: {
          ids_humor: value.ids_humor
        }
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultHumorQuestions', { ids: value.ids_humor });
        })
    },
    async removeHumorMeditationMusic(context, value) {
      console.log('REMOVE HUMOR MEDITATION MUSIC', value);

      const elementExist = context.getters.humorQuestion.humorHasMeditationMusic.some(obj => obj.id === value.id);
      if (!elementExist) return;

      await axiosInstance({
        method: 'DELETE',
        url: `humor/music/${value.id}`,
        data: {
          ids_humor: value.ids_humor
        }
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultHumorQuestions', { ids: value.ids_humor });
        })
    },
    async removeAllQuestions(context, value) {
      console.log('REMOVE ALL QUESTIONS', value);

      await axiosInstance({
        method: 'DELETE',
        url: `humor/question`,
        data: {
          ids_humor: value.ids_humor,
          ids_humor_question: value.ids_humor_question
        }
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultHumorQuestions');
        })
    },
    setCurrentTask(context, value) {
      context.commit('SET_CURRENT_TASK', value);
    },
    setDataDefault(context, [mutationName, value]) {
      context.commit(`${mutationName}`, value);
    },
  }
}
